<app-modal-header title="Clock Out"></app-modal-header>
<ion-content class="time-modal-content">
  <app-time
    *ngIf="!isLoading"
    [userId]="userId"
    [interval]="INTERVAL"
    [timeFormControlParams]="timeFormControlParams"
    (formValuesChanged)="onTimeFormValuesChanged($event)"
  ></app-time>

  <app-clock-odometer-value
    *ngIf="formValues.time"
    [userId]="userId"
    [date]="formValues.time.selectedDate"
    [currentProjectId]="formValues.time.projectId"
    [nextProjectId]="null"
    (valueChanged)="onClockOdometerValuesChanged($event)"
  ></app-clock-odometer-value>

  <app-footer-buttons-spacer></app-footer-buttons-spacer>
</ion-content>
<app-footer-buttons
  *ngIf="formValues.time && formValues.clockOdometer"
  [rightButton]="{ text: 'Submit', disabled: !formValues?.time.isValid || !formValues?.clockOdometer.isValid }"
  (rightButtonClicked)="onSave()"
  (rightButtonDisabledClicked)="validateFields()"
></app-footer-buttons>
